import { createImageSizeSource } from "./imageSize";
const MIN_IMAGE_WIDTH = 5;
const MAX_IMAGE_WIDTH = 100;
export const createImageResize = ({ view, container, frame, image, handle, controls, imageTo, decorationTo, initialWidth }) => {
    let active = false;
    let removeOutsideClickListener = null;
    let removeEscapeListener = null;
    const setPreviewWidth = (width) => {
        frame.style.width = `${width}%`;
        image.style.width = "100%";
    };
    const getWidth = (clientX) => {
        const containerRect = container.getBoundingClientRect();
        if (containerRect.width === 0)
            return initialWidth !== null && initialWidth !== void 0 ? initialWidth : MAX_IMAGE_WIDTH;
        const width = Math.round(((clientX - containerRect.left) / containerRect.width) * 100);
        return Math.min(MAX_IMAGE_WIDTH, Math.max(MIN_IMAGE_WIDTH, width));
    };
    const deactivate = () => {
        active = false;
        handle.hidden = true;
        controls.hidden = true;
        frame.classList.remove("cm-markdown-image-frame-selected");
        removeOutsideClickListener === null || removeOutsideClickListener === void 0 ? void 0 : removeOutsideClickListener();
        removeOutsideClickListener = null;
        removeEscapeListener === null || removeEscapeListener === void 0 ? void 0 : removeEscapeListener();
        removeEscapeListener = null;
    };
    handle.addEventListener("pointerdown", (event) => {
        if (event.button !== 0)
            return;
        event.preventDefault();
        event.stopPropagation();
        handle.setPointerCapture(event.pointerId);
        setPreviewWidth(getWidth(event.clientX));
    });
    handle.addEventListener("pointermove", (event) => {
        if (!handle.hasPointerCapture(event.pointerId))
            return;
        setPreviewWidth(getWidth(event.clientX));
    });
    handle.addEventListener("pointerup", (event) => {
        if (!handle.hasPointerCapture(event.pointerId))
            return;
        const width = getWidth(event.clientX);
        handle.releasePointerCapture(event.pointerId);
        view.dispatch({
            changes: {
                from: imageTo,
                to: decorationTo,
                insert: createImageSizeSource(width)
            }
        });
    });
    handle.addEventListener("pointercancel", (event) => {
        if (handle.hasPointerCapture(event.pointerId)) {
            handle.releasePointerCapture(event.pointerId);
        }
        if (initialWidth === null) {
            frame.style.removeProperty("width");
            image.style.removeProperty("width");
        }
        else {
            setPreviewWidth(initialWidth);
        }
        deactivate();
    });
    return {
        activate() {
            if (active)
                return;
            active = true;
            handle.hidden = false;
            controls.hidden = false;
            frame.classList.add("cm-markdown-image-frame-selected");
            const closeOnOutsideClick = (event) => {
                if (event.target instanceof Node && frame.contains(event.target)) {
                    return;
                }
                deactivate();
            };
            document.addEventListener("pointerdown", closeOnOutsideClick);
            removeOutsideClickListener = () => {
                document.removeEventListener("pointerdown", closeOnOutsideClick);
            };
            const closeOnEscape = (event) => {
                if (event.key === "Escape")
                    deactivate();
            };
            document.addEventListener("keydown", closeOnEscape);
            removeEscapeListener = () => {
                document.removeEventListener("keydown", closeOnEscape);
            };
        },
        destroy: deactivate
    };
};
